<style scoped>
h3 {
	margin: 0em 1em 0.25em 0em;
	padding-top: 0.75em;
	font-family: Arial;
	font-weight: normal;
	font-size: 1.8em;
	line-height: 1.35em;
}

select {
	display: block;
}

button {
	margin-top: 15px;
	margin-bottom: 25px;
}

div.separator {
	margin-top: 1em;
	margin-bottom: 2em;
	padding: 0;
	border-bottom: 1px dotted #000;
	font-size: 0.5em;
	line-height: 25%;
}
.jmChecklists {
	border-bottom: 1px solid #efefef;
	border-left: 1px solid #efefef;
	border-right: 1px solid #efefef;
}
.cp {
	cursor: pointer;
}
.nav-item.nav-link.active {
	color: #247cb3 !important;
}
</style>

<template lang="html">
	<div>
		<h3>Checklists</h3>
		<nav>
			<div class="nav nav-tabs" id="nav-tab" role="tablist">
				<a
					class="nav-item nav-link cp"
					v-bind:class="{ active: tab == 'tab1' }"
					v-on:click="setActiveTab('tab1')"
					v-if="jmChecklist"
				>
					{{ jmChecklist.name }}
				</a>

				<a
					class="nav-item nav-link cp"
					v-bind:class="{ active: tab == 'tab2' }"
					v-on:click="setActiveTab('tab2')"
					v-if="submissionChecklist"
					>{{ submissionChecklist.name }}
				</a>
			</div>
		</nav>

		<div class="tab-content" id="nav-tabContent">
			<div
				v-if="tab == 'tab1'"
				v-bind:class="{ active: tab == 'tab1' }"
				class="tab-pane fade show"
				id="nav-home"
				role="tabpanel"
				aria-labelledby="nav-home-tab"
			>
				<div v-if="jmChecklist" class="container-fluid">
					<div
						class="row py-2 jmChecklists"
						v-for="(checklistItem, checklistItemIndex) in jmChecklist.items"
					>
						<div class="col-md-3">
							<p>
								<b>{{ checklistItem.value }}</b>
							</p>
						</div>
						<div class="col-md-4">
							<textarea
								v-if="!checklistItem.completed_at"
								class="w-100"
								type="text"
								v-model="checklistItem.completed_note"
							></textarea>
							<p v-else>
								<span v-if="checklistItem.completed_note">{{
									checklistItem.completed_note
								}}</span>
								<span v-else><i>There was no comment specified.</i></span>
							</p>
						</div>
						<div class="col-md-5">
							<button
								v-if="!checklistItem.completed_at"
								v-class="{ deactive: !checklistItem.completed_note }"
								v-on:click="
									completeChecklistItem(
										jmChecklist,
										checklistItem,
										checklistItemIndex
									)
								"
								>Complete
							</button>
							<span
								v-if="checklistItem.completed_at"
								class="badge badge-success"
								style="font-size: 14px; font-weight: normal"
								><span class="mr-2 fa fa-check"></span> Completed at
								{{ checklistItem.completed_at }} by
								{{ checklistItem.user.full_name }}</span
							>
						</div>
					</div>
				</div>

				<div v-if="!jmChecklist" class="container-fluid">
					JM Checklist Empty
				</div>
			</div>

			<div
				v-if="tab == 'tab2'"
				v-bind:class="{ active: tab == 'tab2' }"
				class="tab-pane fade show"
				id="nav-profile"
				role="tabpanel"
				aria-labelledby="nav-profile-tab"
			>
				<div v-if="submissionChecklist.items.length" class="container-fluid">
					<div
						class="row py-2"
						style="border: 1px solid #efefef"
						v-for="(checklistItem,
						checklistItemIndex) in submissionChecklist.items"
					>
						<div class="col-md-3">
							<p>
								<b>{{ checklistItem.value }}</b>
							</p>
						</div>

						<div class="col-md-4">
							<textarea
								v-if="!checklistItem.completed_at"
								class="w-100"
								type="text"
								v-model="checklistItem.completed_note"
							></textarea>
							<p v-else>{{ checklistItem.completed_note }}</p>
						</div>

						<div class="col-md-5">
							<button
								v-if="!checklistItem.completed_at"
								v-class="{ deactive: !checklistItem.completed_note }"
								v-on:click="
									completeChecklistItem(
										submissionChecklist,
										checklistItem,
										checklistItemIndex
									)
								"
								>Complete
							</button>
							<span
								v-if="checklistItem.completed_at"
								class="badge badge-success"
								style="font-size: 14px; font-weight: normal"
							>
								<span class="mr-2 fa fa-check"></span>
								Completed at {{ checklistItem.completed_at }} by
								{{ checklistItem.user.full_name }}</span
							>
						</div>
					</div>
				</div>

				<div v-if="!submissionChecklist.items.length" class="container-fluid">
					Submission Checklist Empty
				</div>
			</div>
		</div>

		<div class="separator"></div>
	</div>
</template>

<script>
export default {
	props: ["articleId"],
	data: {
		tab: "tab1",
		jmChecklist: null,
		submissionChecklist: null
	},
	methods: {
		getJMChecklist: async function() {
			let response = await axios.get(
				"/api/article-checklists/" + this.articleId + "/jm-checklist"
			);

			this.jmChecklist = response.data;

			this.$forceUpdate();
		},
		getSubmissionChecklist: async function() {
			let response = await axios.get(
				"/api/article-checklists/" + this.articleId + "/submission-checklist"
			);

			this.submissionChecklist = response.data;

			this.$forceUpdate();
		},
		completeChecklistItem: async function(
			checklist,
			checklistItem,
			checklistItemIndex
		) {
			let response = await axios.post(
				"/api/article-checklists/" +
					this.articleId +
					"/submission-checklist/" +
					checklistItem.id,
				checklistItem
			);

			checklist.items[checklistItemIndex] = response.data;

			this.$forceUpdate();
		},
		addChecklistItem: async function(
			checklist,
			checklistItem,
			checklistItemIndex
		) {
			let response = await axios.post(
				"/api/article-checklists/" +
					this.articleId +
					"/submission-checklist/" +
					checklistItem.id,
				checklistItem
			);

			checklist.items[checklistItemIndex] = response.data;

			this.$forceUpdate();
		},
		setActiveTab: function(tab) {
			this.tab = tab;
			this.$forceUpdate();
		}
	},
	created() {
		this.tab = "tab1";
		this.getSubmissionChecklist();
		this.getJMChecklist();
	},
	updated() {
		updateIFrameHeight();
	}
};
</script>
